import React from 'react';
import { Link } from 'react-router-dom';

const PromotionBanner = () => {
  return (
    <div className="bg-gradient-to-r from-emerald-900 to-emerald-800 py-12">
      <div className="max-w-6xl mx-auto px-4">
        <div className="relative">
          {/* Background Elements */}
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute -top-4 left-1/4 w-16 h-16 bg-yellow-300 rounded-full opacity-20"></div>
            <div className="absolute top-1/2 right-1/4 w-12 h-12 bg-yellow-300 rounded-full opacity-20"></div>
            <div className="absolute bottom-0 left-1/3 w-20 h-20 bg-yellow-300 rounded-full opacity-20"></div>
          </div>

          {/* Content */}
          <div className="relative flex flex-col md:flex-row items-center justify-between gap-8">
            {/* Left Side - Text */}
            <div className="flex-1 text-center md:text-left">
              <div className="text-yellow-300 text-6xl md:text-8xl font-bold mb-4 drop-shadow-lg">
                Học Tập
              </div>
              <div className="text-white text-2xl md:text-3xl font-bold mb-2">
                Để Vươn Tới Tương Lai
              </div>
              <div className="text-yellow-100 text-lg mb-6">
                Đồng Hành Cùng Nam Kiến Văn Education
              </div>

              <p className="text-yellow-100 text-base md:text-lg leading-relaxed max-w-xl text-justify">
                <strong className="text-yellow-200">Môi trường học tập tích cực:</strong> Khuyến khích sự chủ động học tập của học sinh.
                Chúng tôi không ngừng nỗ lực để mỗi bài giảng không chỉ là sự truyền tải kiến thức mà còn là nguồn cảm hứng,
                khơi gợi niềm đam mê học hỏi và trang bị cho học sinh những kỹ năng cần thiết để thành công trong tương lai.
                <span className="block mt-2 font-semibold text-yellow-200">
                  Hãy cùng chúng tôi trải nghiệm sự khác biệt từ chất lượng giảng dạy vượt trội!
                </span>
              </p>

            </div>

            {/* Right Side - Decorative Elements */}
            <div className="flex-1 relative">
              <div className="relative z-10">
                <div className="text-9xl">🪙</div>
                <div className="absolute top-8 right-12 text-6xl">💰</div>
                <div className="absolute -bottom-4 left-16 text-7xl">💎</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromotionBanner;
